import React, { useEffect, useState } from 'react';
import { Box, Button, Card, Dialog, Grid, Typography } from '@mui/material';
import { TCLabel, TCTitleLabel } from "components/TopCourtComponents/Label/TopCourtLabel";
import { currencyFormat } from "helper/NumberFormat";
import { fontSize } from "@mui/system";

import icon from "../../../assets/money-in.png";
import { TCInput } from 'components/TopCourtComponents/Input/TopCourtInput';
import { checkIsSAdmin, isMerchant } from 'helper/Admin';
import { createMerchantDeposit } from 'services/merchantServices';
import MerchantDeposit from '../merchant/component/merchantDeposit';
import { Divider } from '@mui/material';
import { toast } from 'react-toastify';
import { getUrlCourtCode } from 'helper/Court';

function VoucherSummary({
    filter, redeemed
}) {
    const [summary, setSummary] = useState({
        redeemed: 0
    })
    const loadSummary = async () => { }
    const styles = {
        summary: {
            minWidth: 50,
            height: 50,
            opacity: '0.3',
            marginLeft: 10,
            background: `url(${icon}) no-repeat top right`,
            backgroundSize: 'contain',
            marginRight: 10
        }
    }
    useEffect(() => {
        setSummary((prev) => ({
            ...prev,
            redeemed
        }))
    }, [redeemed])
    return (
        <Card sx={{ mb: 1 }} className="custom-card-style">
            <Box sx={{ justifyContent: 'center', alignItems: 'center' }}>
                <div style={{
                    justifyContent: 'space-between', alignItems: 'center',
                    display: 'flex'
                }}>
                    <div style={{ width: '100%' }}>
                        <Grid container columnSpacing={2} sx={{ p: 2, alignItems: 'center' }}>
                            <Grid item xs={12} md={isMerchant() ? 3 : 4} sx={{ mb: 1 }}>
                                <Card sx={{
                                    justifyContent: 'center', alignItems: 'center', background: 'whiteSmoke', height: 80, padding: 1, borderRadius: 0,
                                    borderLeft: '5px solid rgb(66, 181, 73)'
                                }}>
                                    <TCLabel style={{
                                        fontSize: 12,
                                        color: 'rgb(133, 133, 133)'
                                    }}>Redeemed Voucher (Session)</TCLabel>
                                    <TCLabel bold style={{
                                        fontSize: 15
                                    }}>{`${summary ? summary.redeemed : '-'}`}</TCLabel>
                                </Card>
                            </Grid>
                        </Grid>
                    </div>
                    {/* <div style={styles.summary}></div> */}
                </div>
            </Box>
        </Card>
    )
}

export default VoucherSummary